import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/hooks/useAuth';
import { analytics } from '@/utils/analytics';

export const ProCTA: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 to-green-600 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl lg:text-3xl font-bold text-white mb-3 leading-tight uppercase">
          Commencez à conseiller avec précision dès aujourd'hui.
        </h2>
        <div className="w-12 h-0.5 bg-white mx-auto mb-6"></div>

        <p className="text-lg text-white/90 mb-8 max-w-4xl mx-auto">
          Rejoignez les professionnels de l'immobilier et de la rénovation qui utilisent DPEWizard pour conseiller leurs clients avec des données fiables et des scénarios concrets.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <Button
            size="lg"
            variant="outline"
            className="bg-white text-blue-600 border-white hover:bg-blue-50"
            onClick={() => {
              analytics.trackEvent({
                action: 'click',
                category: 'engagement',
                label: 'pro_final_cta',
                custom_parameters: {
                  user_authenticated: isAuthenticated
                }
              });
              navigate(isAuthenticated ? '/dashboard' : '/auth?mode=signup');
            }}
          >
            Accéder à DPEWizard Pro
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ProCTA;
